import { VuexModule } from 'vuex-module-decorators'

export default class BaseStore extends VuexModule {}
